<template>
  <div class="single-wrap">
    <nav class="navigation navigation--is-fixed">
      <ul class="navigation__list">
        <li class="navigation__item" v-for="(field, index) in post.acf.field" :key="index">
          <button class="navigation__link" v-scroll-to="{
          el: urlFriendly(field.title),
          offset: -290
        }">
            {{ field.title }}
          </button>
        </li>
      </ul>
    </nav>
    <article>
      <div v-for="(field, index) in post.acf.field" :key="index">
        <div class="field" :id="field.title | url">
          <div v-html="field.content"></div>
        </div>
      </div>
      <div v-if="post.acf.imprint_text">
        <div class="hidden-content">
          <button @click="collapsed = !collapsed" class="hidden-content__trigger">Impressum</button>
          <div class="hidden-content__text" :class="{'hidden-content__text--hide' : collapsed}" v-html="post.acf.imprint_text"></div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  props: ['post'],

  data () {
    return {
      collapsed: true
    }
  },

  filters: {
    url: function (value) {
      value = value.toLowerCase()
      value = value.replace(/ä/g, 'ae')
      value = value.replace(/ö/g, 'oe')
      value = value.replace(/ü/g, 'ue')
      value = value.replace(/ß/g, 'ss')
      value = value.replace(/ /g, '-')
      value = value.replace(/\./g, '')
      value = value.replace(/,/g, '')
      value = value.replace(/\(/g, '')
      value = value.replace(/\)/g, '')
      return value
    }
  },

  methods: {
    urlFriendly (value) {
      value = value.toLowerCase()
      value = value.replace(/ä/g, 'ae')
      value = value.replace(/ö/g, 'oe')
      value = value.replace(/ü/g, 'ue')
      value = value.replace(/ß/g, 'ss')
      value = value.replace(/ /g, '-')
      value = value.replace(/\./g, '')
      value = value.replace(/,/g, '')
      value = value.replace(/\(/g, '')
      value = value.replace(/\)/g, '')
      return '#' + value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/SinglePost.vue